<template>
    <div>
        <Table :isEmpty="localServicePrices.length === 0">
            <TableHead>
                <TableHeadCell>Amount</TableHeadCell>
                <TableHeadCell>Currency</TableHeadCell>
                <TableHeadCell></TableHeadCell>
            </TableHead>
            <TableBody>
                <TableBodyRow
                    v-for="servicePrice in localServicePrices"
                    :key="servicePrice.id.value"
                >
                    <TableBodyRowCell>
                        {{ servicePrice.price.getValueAsDecimal() }}
                    </TableBodyRowCell>
                    <TableBodyRowCell>
                        {{ servicePrice.price.currency }}
                    </TableBodyRowCell>
                    <TableBodyRowCell class="flex justify-end gap-1">
                        <EditServicePriceButtonDrawer
                            :servicePrice="servicePrice"
                            @onSuccess="handleServicePriceUpdated($event)"
                        />
                        <DeleteServicePriceButtonModal
                            :servicePrice="servicePrice"
                            @onSuccess="handleServicePriceDeleted(servicePrice)"
                        />
                    </TableBodyRowCell>
                </TableBodyRow>
            </TableBody>

            <template #emptyState>
                <TableEmptyState
                    title="No prices"
                    subtitle="Your service has no price defined yet. Click the button below to create the first one."
                >
                    <template #action>
                        <CreateServicePriceButtonDrawer
                            :service="service"
                            @onSuccess="handleServicePriceCreated($event)"
                        />
                    </template>
                </TableEmptyState>
            </template>
        </Table>
        <div
            v-if="localServicePrices.length > 0"
            class="flex items-center justify-end mt-4"
        >
            <CreateServicePriceButtonDrawer
                :service="service"
                @onSuccess="handleServicePriceCreated($event)"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType, ref } from 'vue'
    import Service from '@/App/Service/Entity/Service'
    import ServicePrice from '@/App/Service/Entity/ServicePrice'
    import ServiceAggregate from '@/App/Service/Entity/ServiceAggregate'

    import CreateServicePriceButtonDrawer from '@/App/Service/Component/ServicePrice/CreateServicePriceButtonDrawer.vue'
    import EditServicePriceButtonDrawer from '@/App/Service/Component/ServicePrice/EditServicePriceButtonDrawer.vue'
    import DeleteServicePriceButtonModal from '@/App/Service/Component/ServicePrice/DeleteServicePriceButtonModal.vue'

    import Table from '@/Shared/Component/Table/Table.vue'
    import TableHead from '@/Shared/Component/Table/TableHead.vue'
    import TableHeadCell from '@/Shared/Component/Table/TableHeadCell.vue'
    import TableBody from '@/Shared/Component/Table/TableBody.vue'
    import TableBodyRow from '@/Shared/Component/Table/TableBodyRow.vue'
    import TableBodyRowCell from '@/Shared/Component/Table/TableBodyRowCell.vue'
    import TableEmptyState from '@/Shared/Component/Table/TableEmptyState.vue'

    const props = defineProps({
        service: {
            type: Object as PropType<Service>,
            required: true,
        },
        servicePrices: {
            type: Object as PropType<ServicePrice[]>,
            required: true,
        },
    })

    const localServicePrices = ref<ServicePrice[]>(props.servicePrices)

    const handleServicePriceUpdated = (serviceAggregate: ServiceAggregate) => {
        localServicePrices.value = serviceAggregate.servicePrices
    }

    const handleServicePriceCreated = (serviceAggregate: ServiceAggregate) => {
        localServicePrices.value = serviceAggregate.servicePrices
    }

    const handleServicePriceDeleted = (servicePrice: ServicePrice) => {
        localServicePrices.value = localServicePrices.value.filter(
            (availability) => {
                return availability.id.value !== servicePrice.id.value
            },
        )
    }
</script>
